module.exports = __webpack_public_path__ + "assets/img/warrior-name-dd2d5356.png";